import { getSubscriptionManager } from '../events/subscriptions';
import { getUniformQueue } from '../events/queue';
export function initializeGlobalObject(logger) {
  if (!window) {
    logger.error("initializeGlobalObject - Window global object is not available so Uniform global object cannot be initialized.");
    return;
  }
  if (!window.uniform) {
    window.uniform = {};
    logger.debug("initializeGlobalObject - Uniform global object was created.");
  }
  if (!window.uniform.subscriptions) {
    window.uniform.subscriptions = getSubscriptionManager("GLOBAL_SUBS", true);
    logger.debug("initializeGlobalObject - Subscription manager was added to Uniform global object.", {
      subscriptionManager: window.uniform.subscriptions.id
    });
  }
  if (!window.uniform.queue) {
    window.uniform.queue = getUniformQueue("GLOBAL_QUEUE");
    logger.debug("initializeGlobalObject - Queue was added to Uniform global object.", {
      queueId: window.uniform.queue.id
    });
  }
}